import { store } from '@/redux-store';
import { permissionManager } from '@/utils/permission';
import { routeManager } from '@/utils/route';

interface UseGuardProps {
    routeKey: string;
}

const useGuard = ({ routeKey }: UseGuardProps) => {
    const user = store.getState().auth.user;

    const userPermission = user?.permissions || [];

    const getInfoPage = routeManager.getRouteMap()[routeKey];

    const hasPermission = permissionManager.hasPermission(
        getInfoPage.permissions,
        userPermission
    );

    return hasPermission;
};

export default useGuard;
